import React from 'react';
import { AuthInfo } from '.';



interface Props {
  children: any;
}

const AuthLayout: React.FC<Props> = ({ children }) => {
  return (
    <div className="w-full overflow-x-hidden  ">
      <div className="flex min-h-screen border ">
        <div className="hidden lg:block w-full lg:w-1/2 ">
          <AuthInfo />
        </div>
        <div className="w-full lg:w-1/2 bg-[#F2F9FD]">{children}</div>
      </div>
    </div>
  );
};

export { AuthLayout };
